/** Matches the legacy DOM renderer by excluding both horizontal/vertical offsets. */
export const getPegboardHoleCount = (size: number, offset: number, gap: number) =>
  Number.isFinite(size) && Number.isFinite(offset) && Number.isFinite(gap) && gap > 0
    ? Math.abs(Math.floor((size - 2 * offset) / gap))
    : 0;

export const getPegboardHoleCounts = ({
  width,
  height,
  holesOffsetHorizontal,
  holesOffsetVertical,
  holesGapHorizontal,
  holesGapVertical,
}: {
  width: number;
  height: number;
  holesOffsetHorizontal: number;
  holesOffsetVertical: number;
  holesGapHorizontal: number;
  holesGapVertical: number;
}) => ({
  horizontal: getPegboardHoleCount(width, holesOffsetHorizontal, holesGapHorizontal),
  vertical: getPegboardHoleCount(height, holesOffsetVertical, holesGapVertical),
});
